import React from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

import { getCroppedImgBlob } from 'utils/files/images';

import styles from './styles.module.scss';

const ImageCropper = ({
  activeTaskName,
  crop,
  croppedImageUrl,
  croppingActive,
  previewImage,
  sourceImage,
  setCrop,
  setCroppedBlob,
  setCroppedImageUrl,
  setSourceImage,
  uploadedImageBlob
}) => {
  // TODO: consider removing the whole component or create some store for all of that state
  const onImageLoaded = (img) => {
    setSourceImage(img);
  };

  const onCropComplete = (crop) => {
    makeClientCrop({ crop });
  };

  async function makeClientCrop({ crop }) {
    if (sourceImage && crop.width && crop.height) {
      const blob = await getCroppedImgBlob({ sourceImage, crop }); // returns a Blob
      setCroppedBlob(blob);
      const url = URL.createObjectURL(blob);
      setCroppedImageUrl(url);
    }
  }

  const imageSrc = previewImage || uploadedImageBlob;

  return (
    <div className={styles.cropContainer}>
      {imageSrc && croppingActive && (
        <ReactCrop
          src={imageSrc}
          crop={crop}
          keepSelection
          ruleOfThirds
          onImageLoaded={onImageLoaded}
          onChange={setCrop}
          onComplete={onCropComplete}
          draggable={false}
        />
      )}
      {(croppedImageUrl || uploadedImageBlob) && !croppingActive && (
        <img
          alt={`Cropped document of ${activeTaskName}`}
          style={{ maxWidth: '100%' }}
          src={croppedImageUrl || previewImage}
        />
      )}
    </div>
  );
};

export default ImageCropper;
